import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPlaidLinkModule } from "ngx-plaid-link";
import { SignupComponent } from './components/signup/signup.component';
import { createCustomElement } from '@angular/elements';
import { Signup01Component } from './components/signup01/signup01.component';
import { Signup02Component } from './components/signup02/signup02.component';
import { Signup03Component } from './components/signup03/signup03.component';
import { Signup04Component } from './components/signup04/signup04.component';
import { Signup05Component } from './components/signup05/signup05.component';
import { Signup06Component } from './components/signup06/signup06.component';
import { StoreModule } from '@ngrx/store';
import { featureKey, reducer, SignupDataEffects, SignupCategoriesEffects } from './features';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { CoreModule } from '../core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconModule } from '../icon/icon.module';
import { DialogModule } from 'app/dialog/dialog.module';
import { ToastModule } from '../toast/toast.module';
import { GoogleMapsAutocompleteModule } from 'app/google-maps-autocomplete/google-maps-autocomplete.module';
import { QuillModule  } from 'ngx-quill'
import Counter from './features/counter';

import { AccountRoutingNumberComponent } from './components/modals/account-routing-number/account-routing-number.component';

import { NgxCurrencyInputMode, provideEnvironmentNgxCurrency, NgxCurrencyDirective } from "ngx-currency";
import { ChangeEmailComponent } from './components/modals/change-email/change-email.component';
import { ContactUsComponent } from './components/modals/contact-us/contact-us.component';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { MdbRadioModule } from 'mdb-angular-ui-kit/radio';
import { InputMaskModule } from '@ngneat/input-mask';
import { MdbInputGoogleMapsAutocompleteComponent } from 'app/core/components/mdb-input-google-maps-autocomplete/mdb-input-google-maps-autocomplete.component';
import { NgxPlaidLinkWrapperComponent } from './components/ngx-plaid-link-wrapper/ngx-plaid-link-wrapper.component';

@NgModule({
  declarations: [
    SignupComponent,
    Signup01Component,
    Signup02Component,
    Signup03Component,
    Signup04Component,
    Signup05Component,
    Signup06Component,
    AccountRoutingNumberComponent,
    ChangeEmailComponent,
    ContactUsComponent
  ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        StoreModule.forRoot({}, {
          runtimeChecks: {
            strictStateImmutability: false,
            strictActionImmutability: false,
          },
        }),
        StoreModule.forFeature(featureKey, reducer),
        EffectsModule.forRoot([]),
        EffectsModule.forFeature([SignupDataEffects, SignupCategoriesEffects]),
        StoreDevtoolsModule.instrument({
            maxAge: 25, // Retains last 25 states
        }),
        NgxPlaidLinkModule,
        CoreModule,
        IconModule,
        DialogModule,
        ToastModule,
        GoogleMapsAutocompleteModule,
        MdbFormsModule,
        MdbSelectModule,
        MdbRadioModule,
        InputMaskModule,
        QuillModule.forRoot({
          customModules: [{
            implementation: Counter,
            path: 'modules/counter'
          }]
        }),
        NgxCurrencyDirective,
        MdbInputGoogleMapsAutocompleteComponent,
        NgxPlaidLinkWrapperComponent
    ],
  providers: [provideEnvironmentNgxCurrency({
    align: "left",
    allowNegative: false,
    allowZero: true,
    decimal: ".",
    precision: 0,
    prefix: "$ ",
    suffix: "",
    thousands: ",",
    nullable: true,
    min: null,
    max: null,
    inputMode: NgxCurrencyInputMode.Financial
  })],
})
export class SignupModule {
  constructor(injector: Injector) {
    const SignupElement = createCustomElement(SignupComponent, {injector});

    try {
      customElements.define('paybee-signin-element', SignupElement);
    } catch(e) {}
  }
}
